<template>
  <section class="page-side">
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: 'PageSide',
  components: {}
}
</script>

<style lang="postcss">
.page-side {
  @apply hidden flex-shrink-0;
}
@screen lg {
  .page-side {
    @apply block w-1/4 px-4 mr-1/12 self-start;
    position: sticky;
    top: 104px;
  }
}
</style>

